import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Title from "@/stills/Title";

export default function TitlePage() {
  const { id } = useParams();
  useEffect(() => {
    document.documentElement.style.background = "transparent";
    document.body.style.background = "transparent";
  }, []);
  return (
    <div data-testid="title-root" style={{ width: "100vw", height: "100vh", overflow: "hidden", background: "transparent" }}>
      <Title id={id} />
    </div>
  );
}
